import * as Yup from 'yup';

const confirmChangesValidationSchema = (isRefund, skipImmediateBillOrRefund, trailingDocChanges, isAgency) =>
  Yup.object().shape({
    notes: Yup.string()
      .ensure()
      .trim()
      .test('minLength20Prod', 'Internal notes must be 20 characters in length or more.', (value) => {
        return (
          import.meta.env.NODE_ENV === 'development' || window.location.hostname.includes('dev') || value.length >= 19
        );
      })
      .test('noEmail', 'Email addresses are not allowed in internal notes.', (value) => {
        return !value.includes('@');
      })
      .required('Internal notes are required!'),
    allowRefund: Yup.boolean().test('do not delay refunds check', 'Do not delay refunds unless necessary', (value) => {
      if (!isRefund) {
        return true;
      }
      if (!skipImmediateBillOrRefund) {
        return true;
      }
      if (skipImmediateBillOrRefund && isRefund) {
        return value;
      }
    }),
    signedDocumentsRequiredCheckbox: Yup.boolean().test(
      'signed document attestation',
      'Agent must attest to having the necessary documentation before continuing',
      (value) => (trailingDocChanges?.length && isAgency ? value : true)
    )
  });

const approveRequestedChangesValidationSchema = () =>
  Yup.object().shape({
    preAcceptChangesVerification: Yup.boolean().test(
      'pre accept changes verification',
      'You must attest to having verified the above before continuing',
      (value) => value
    ),
    notes: Yup.string()
      .ensure()
      .trim()
      .test('minLength20Prod', 'Internal notes must be 20 characters in length or more.', (value) => {
        return (
          import.meta.env.NODE_ENV === 'development' || window.location.hostname.includes('dev') || value.length >= 19
        );
      })
      .test('noEmail', 'Email addresses are not allowed in internal notes.', (value) => {
        return !value.includes('@');
      })
      .required('Internal notes are required!')
  });

const requestChangesForApprovalValidationSchema = (changesForApprovalConfig) =>
  Yup.object().shape({
    proofOfElegibilityDocumentsAttestation: Yup.boolean().test(
      'proof of elegibility documents attestation',
      'Agent must attest to having the necessary documentation before continuing',
      (value) => (changesForApprovalConfig?.showProofOfEligibilityDocumentsBlock ? value : true)
    ),
    allHouseholdResidentsIncludedAttestation: Yup.boolean().test(
      'all household residents included attestation',
      'Agent must attest to having included all household residents before continuing',
      (value) => (changesForApprovalConfig?.showAllHouseholdResidentsIncludedBlock ? value : true)
    ),
    policyChangesDescription: Yup.string().trim()
  });

const changesForApprovalValidationSchema = (canApproveRequestedPIPChanges, changesForApprovalConfig) =>
  canApproveRequestedPIPChanges
    ? approveRequestedChangesValidationSchema()
    : requestChangesForApprovalValidationSchema(changesForApprovalConfig);

export const validationSchema = (
  isRefund,
  skipImmediateBillOrRefund,
  trailingDocChanges,
  isAgency,
  canApproveRequestedPIPChanges,
  changesForApprovalConfig
) =>
  changesForApprovalConfig?.hasChangesThatNeedApproval
    ? changesForApprovalValidationSchema(canApproveRequestedPIPChanges, changesForApprovalConfig)
    : confirmChangesValidationSchema(isRefund, skipImmediateBillOrRefund, trailingDocChanges, isAgency);
